import { useEffect, useState } from 'react'
import { RootState, useSelector } from 'redux/store'
import { UIContractState as Guarantee } from '../@types/UIContractState'

// Helpers

export const getRequestType = (pRow: Guarantee) => {
  if (pRow && pRow?.TriContractState) {
    const { subStateDisplay, stateDisplay } = pRow.TriContractState
    return subStateDisplay ? `(${subStateDisplay})` : stateDisplay
  }
}

// ----------------------------------------------------------------------

export const useOrgTasks = () => {
  const { allGuarantees, isLoading } = useSelector((state: RootState) => state?.allGuarantees)
  const [orgTasks, setOrgTasks] = useState<Guarantee[]>([])

  useEffect(() => {
    const filteredTasks: Guarantee[] = allGuarantees?.filter((gx: Guarantee) => {
      const { organizationTask } = gx
      return organizationTask
    })
    setOrgTasks(filteredTasks)
  }, [allGuarantees])

  return { orgTasks, isLoading }
}
